(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.querySelectorAll('[data-announcement]').forEach(function (root) {
      var autoRotate = root.dataset.autoRotate === 'true';
      var slides = Array.from(root.querySelectorAll('[data-announcement-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-announcement-dot]'));
      var seconds = parseInt(root.dataset.rotateSeconds, 10) || 5;
      if (slides.length < 2) return;

      var idx = 0;
      var timer = null;

      function goTo(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }

      function next() { goTo(idx + 1); }

      function start() {
        if (!autoRotate || timer) return;
        timer = setInterval(next, seconds * 1000);
      }
      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      // Pausar al hover y al cambiar de pestaña
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      // Click en dots
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () {
          goTo(n);
          stop();
          start();
        });
      });

      start();

      // Pausar si el usuario prefiere reducir movimiento
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stop();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var banner = document.getElementById('LocaleHintBanner');
    if (!banner) return;

    // La clave decía `mga_` — era la de MG Alianza, arrastrada de otra tienda.
    var STORAGE_KEY = 'pinton_locale_hint_dismissed_v1';
    var SESION_KEY = 'pinton_locale_hint_visto_sesion';
    // Cerrado a mano: no vuelve nunca. Apagado solo: no vuelve en esta visita,
    // pero sí en la siguiente, porque puede que no le diera tiempo a leerlo.
    try { if (localStorage.getItem(STORAGE_KEY)) return; } catch (e) { /* ignore */ }
    try { if (sessionStorage.getItem(SESION_KEY)) return; } catch (e) { /* ignore */ }

    var currentLocale = (banner.dataset.currentLocale || '').toLowerCase();
    var availableLocales = (banner.dataset.availableLocales || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var navLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase().split('-')[0];

    if (!availableLocales.length || !navLang) return;
    if (navLang === currentLocale) return;
    if (availableLocales.indexOf(navLang) === -1) return;

    var messages = {
      es: { text: 'Tu navegador está en español. ¿Quieres ver la tienda en español?', cta: 'Cambiar a español' },
      en: { text: 'Your browser is in English. View the store in English?', cta: 'Switch to English' },
      fr: { text: 'Votre navigateur est en français. Voir la boutique en français ?', cta: 'Passer au français' },
      de: { text: 'Ihr Browser ist auf Deutsch. Shop auf Deutsch anzeigen?', cta: 'Auf Deutsch umstellen' },
      it: { text: 'Il tuo browser è in italiano. Visualizza il negozio in italiano?', cta: 'Passa all’italiano' },
      pt: { text: 'O seu navegador está em português. Ver a loja em português?', cta: 'Mudar para português' }
    };
    var msg = messages[navLang] || messages.en;

    var textEl = banner.querySelector('[data-hint-text]');
    var ctaLabel = banner.querySelector('[data-hint-switch-label]');
    var ctaBtn = banner.querySelector('[data-hint-switch]');
    var dismissBtn = banner.querySelector('[data-hint-dismiss]');

    if (textEl) textEl.textContent = msg.text;
    if (ctaLabel) ctaLabel.textContent = msg.cta;

    banner.hidden = false;

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var form = document.createElement('form');
        form.method = 'POST';
        // Se normaliza la raíz: en inglés `Shopify.routes.root` vale "/" y
        // concatenar daba "//localization", que el navegador lee como un
        // dominio. Es el mismo fallo que tenía el <select> del pie.
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        form.action = root.replace(/\/+$/, '') + '/localization';
        form.style.display = 'none';
        var method = document.createElement('input');
        method.type = 'hidden'; method.name = '_method'; method.value = 'put';
        var locale = document.createElement('input');
        locale.type = 'hidden'; locale.name = 'locale_code'; locale.value = navLang;
        var returnTo = document.createElement('input');
        returnTo.type = 'hidden'; returnTo.name = 'return_to'; returnTo.value = window.location.pathname + window.location.search;
        form.appendChild(method); form.appendChild(locale); form.appendChild(returnTo);
        document.body.appendChild(form);
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignore */ }
        form.submit();
      });
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        banner.hidden = true;
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignore */ }
      });
    }

    /* --- Que se apague solo -------------------------------------------------
       El aviso se quedaba en pantalla hasta que alguien lo tocaba. En un móvil
       de 375 px eso son unos 70 px ocupados toda la visita, y en la ficha se
       sienta justo encima de la barra de comprar.

       A los 12 s se retira con el desvanecido de arriba. Y se recuerda EN LA
       SESIÓN, no para siempre: si se guardara en `localStorage` como el botón
       de cerrar, quien no llegó a leerlo no lo vería nunca más. Así no vuelve a
       salir mientras navega, y en otra visita tiene una segunda oportunidad.

       El reloj se PARA si el ratón está encima, si el dedo lo toca o si el foco
       del teclado entra: nadie debería ver cómo se le va el aviso mientras lo
       está leyendo. Al salir, vuelve a arrancar. */
    var ESPERA = 12000;
    var reloj = null;

    function apagar() {
      banner.classList.add('is-apagando');
      try { sessionStorage.setItem(SESION_KEY, '1'); } catch (e) { /* ignore */ }
      // `hidden` al terminar el desvanecido, no antes: `hidden` corta la
      // transición en seco y el aviso desaparecería de golpe.
      window.setTimeout(function () { banner.hidden = true; }, 600);
    }
    function arrancar() {
      if (reloj) window.clearTimeout(reloj);
      reloj = window.setTimeout(apagar, ESPERA);
    }
    function parar() {
      if (reloj) { window.clearTimeout(reloj); reloj = null; }
    }

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      banner.addEventListener(ev, parar, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      banner.addEventListener(ev, arrancar);
    });

    /* La cuenta atrás NO empieza si la pestaña está en segundo plano. Medido
       aquí mismo: abriendo la tienda en una pestaña de fondo, `visibilityState`
       vale "hidden", el navegador congela la animación de entrada y, si el
       reloj corriera igual, los 12 s se gastarían antes de que nadie mire.
       Se espera a que la pestaña esté delante; si se va, se para. */
    function segunVisibilidad() {
      if (document.hidden) { parar(); } else { arrancar(); }
    }
    document.addEventListener('visibilitychange', segunVisibilidad);
    segunVisibilidad();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-main-collection]');
    if (!section) return;

    const sectionId = section.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
    const resultsContainer = section.querySelector('[data-collection-results]');
    const resultsId = resultsContainer ? resultsContainer.id : null;

    const cache = new Map();
    let currentAbort = null;
    let debounceTimer = null;

    function buildSearchParams() {
      const params = new URLSearchParams();
      section.querySelectorAll('[data-collection-filter-form] input[type="checkbox"]:checked').forEach((i) => {
        params.append(i.name, i.value);
      });
      section.querySelectorAll('[data-collection-filter-form] input[type="number"]').forEach((i) => {
        if (i.value) params.append(i.name, i.value);
      });
      const sortField = section.querySelector('[data-collection-sort]');
      if (sortField && sortField.value) params.set('sort_by', sortField.value);
      return params;
    }

    function applyHtmlFragment(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(resultsId);
      if (fresh && resultsContainer) {
        resultsContainer.innerHTML = fresh.innerHTML;
      }
      const freshCount = doc.querySelector('[data-product-count]');
      const liveCount = section.querySelector('[data-product-count]');
      if (freshCount && liveCount) liveCount.innerHTML = freshCount.innerHTML;
    }

    function fetchAndRender(searchParams) {
      if (!sectionId || !resultsId) {
        const url = window.location.pathname + (searchParams.toString() ? '?' + searchParams : '');
        window.location.href = url;
        return;
      }
      const url = `${window.location.pathname}?section_id=${sectionId}${searchParams.toString() ? '&' + searchParams : ''}`;
      const newUrl = window.location.pathname + (searchParams.toString() ? '?' + searchParams : '');
      history.pushState({ params: searchParams.toString() }, '', newUrl);

      if (cache.has(url)) {
        applyHtmlFragment(cache.get(url));
        resultsContainer.classList.remove('is-loading');
        return;
      }

      if (currentAbort) currentAbort.abort();
      currentAbort = new AbortController();
      resultsContainer.classList.add('is-loading');

      fetch(url, { signal: currentAbort.signal })
        .then((res) => res.text())
        .then((html) => {
          cache.set(url, html);
          applyHtmlFragment(html);
          resultsContainer.classList.remove('is-loading');
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          resultsContainer.classList.remove('is-loading');
          window.location.href = newUrl;
        });
    }

    function scheduleFetch() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fetchAndRender(buildSearchParams()), 250);
    }

    // Event delegation from section root (survives DOM replacement)
    section.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-collection-filter-form] input[type="checkbox"], [data-collection-filter-form] input[type="number"]')) {
        scheduleFetch();
      } else if (t.matches('[data-collection-sort]')) {
        scheduleFetch();
      }
    });

    section.addEventListener('submit', (e) => {
      if (e.target.matches('[data-collection-filter-form]')) {
        e.preventDefault();
        scheduleFetch();
      }
    });

    // Browser back/forward
    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);
      fetchAndRender(params);
    });

    // Desktop sidebar toggle
    section.addEventListener('click', (e) => {
      const desktopBtn = e.target.closest('[data-filter-toggle-desktop]');
      const mobileBtn = e.target.closest('[data-filter-toggle-mobile]');
      const drawerClose = e.target.closest('[data-filter-drawer-close]');
      const colsBtn = e.target.closest('.cols-switch__btn');

      if (desktopBtn) {
        const sidebar = section.querySelector('[data-filter-sidebar-desktop]');
        const body = section.querySelector('.main-collection__body');
        const txt = desktopBtn.querySelector('[data-toggle-text]');
        const isOpen = desktopBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          if (sidebar) sidebar.style.display = 'none';
          if (body) body.classList.add('main-collection__body--no-filters');
          desktopBtn.setAttribute('aria-expanded', 'false');
          if (txt) txt.textContent = desktopBtn.dataset.showLabel || 'Show filters';
        } else {
          if (sidebar) sidebar.style.display = '';
          if (body) body.classList.remove('main-collection__body--no-filters');
          desktopBtn.setAttribute('aria-expanded', 'true');
          if (txt) txt.textContent = desktopBtn.dataset.hideLabel || 'Hide filters';
        }
      }

      if (mobileBtn) {
        const drawer = section.querySelector('[data-filter-drawer]');
        if (drawer) {
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('no-scroll');
        }
      }

      if (drawerClose) {
        const drawer = section.querySelector('[data-filter-drawer]');
        if (drawer) {
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('no-scroll');
        }
      }

      if (colsBtn) {
        const cols = colsBtn.dataset.cols;
        section.querySelectorAll('.cols-switch__btn').forEach((b) => b.classList.toggle('is-active', b === colsBtn));
        const grid = section.querySelector('[data-collection-grid]');
        if (grid) grid.style.setProperty('--cols', cols);
      }
    });

    // Init: mark active grid switcher
    const defaultCols = section.dataset.defaultCols || '3';
    section.querySelectorAll('.cols-switch__btn').forEach((b) => {
      if (b.dataset.cols === defaultCols) b.classList.add('is-active');
    });

    // Persist toggle labels for i18n
    const desktopBtnInit = section.querySelector('[data-filter-toggle-desktop]');
    if (desktopBtnInit) {
      const txt = desktopBtnInit.querySelector('[data-toggle-text]');
      desktopBtnInit.dataset.hideLabel = desktopBtnInit.dataset.hideLabel || (txt ? txt.textContent.trim() : 'Hide filters');
      desktopBtnInit.dataset.showLabel = desktopBtnInit.dataset.showLabel || 'Show filters';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const thumbs = section.querySelectorAll('[data-pm-thumb]');
    const mains = section.querySelectorAll('[data-pm-main-item]');

    /* Contador "N / 9". Cuenta sobre las miniaturas VISIBLES, no sobre el
       total: al filtrar por variante el numerador y el denominador tienen que
       hablar de la misma galeria. */
    const contador = section.querySelector('[data-pm-count]');
    const contadorNum = section.querySelector('[data-pm-count-current]');
    const refrescarContador = () => {
      if (!contador || !contadorNum) return;
      const visibles = Array.from(thumbs).filter((t) => !t.hidden);
      const activa = visibles.findIndex((t) => t.classList.contains('is-active'));
      contadorNum.textContent = activa >= 0 ? activa + 1 : 1;
      contador.lastChild.textContent = ' / ' + visibles.length;
    };

    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const idx = t.dataset.pmThumb;
        thumbs.forEach((x) => x.classList.toggle('is-active', x.dataset.pmThumb === idx));
        mains.forEach((m) => m.classList.toggle('is-active', m.dataset.pmMainItem === idx));
        refrescarContador();
      });
    });

    /* ---- Visor ampliado (lightbox) ---------------------------------------
       Abrir/cerrar, Escape, clic fuera, cepo de foco y bloqueo de scroll ya
       los da el Drawer generico de theme.js sobre [data-drawer] (el boton
       lleva data-drawer-open apuntando al id del visor). Aqui solo hace
       falta: saber que foto tocaba, pintarla, y mover el indice con las
       flechas, el teclado o el dedo.

       Foto grande sin pedirla al montar la pagina: se enseña al momento la
       MISMA imagen que ya estaba cargada en la galeria (mismo currentSrc,
       0 peticiones nuevas) y, en cuanto carga, se cambia en silencio por una
       version mas ancha (?width=2000) pedida al CDN de Shopify -que ya
       negocia WebP solo, esta comprobado con curl en el informe de
       velocidad-. Si esa version mayor falla o tarda, el visor se queda con
       la que ya tenia: nunca se ve un hueco en blanco. */
    /* El visor vive FUERA de <section data-product-section> (es un overlay a
       pantalla completa, no tiene por que competir por la rejilla del
       producto), asi que no aparece con section.querySelector: se busca por
       el id que comparte con section.dataset.sectionId. */
    const lightbox = document.getElementById('pm-lightbox-' + section.dataset.sectionId);
    if (lightbox) {
      const stageImg = lightbox.querySelector('[data-pm-lightbox-img]');
      const countActual = lightbox.querySelector('[data-pm-lightbox-count-current]');
      const countTotal = lightbox.querySelector('[data-pm-lightbox-count-total]');
      let indiceZoom = 0;

      const piezasAmpliables = () => Array.from(mains).filter(
        (m) => m.dataset.mediaType === 'image' && m.dataset.hiddenByVariant !== '1'
      );

      const pedirGrande = (urlPequena) => {
        let grande;
        try {
          grande = new URL(urlPequena, window.location.href);
          grande.searchParams.set('width', '2000');
        } catch (e) {
          return;
        }
        const previa = new Image();
        previa.onload = () => { stageImg.src = grande.toString(); };
        previa.src = grande.toString();
      };

      const pintarZoom = () => {
        const piezas = piezasAmpliables();
        const item = piezas[indiceZoom];
        const img = item && item.querySelector('img');
        if (!img || !stageImg) return;
        const urlActual = img.currentSrc || img.src;
        stageImg.src = urlActual;
        stageImg.alt = img.alt || '';
        if (countActual) countActual.textContent = indiceZoom + 1;
        if (countTotal) countTotal.textContent = piezas.length;
        pedirGrande(urlActual);
      };

      const irAZoom = (i) => {
        const piezas = piezasAmpliables();
        if (!piezas.length) return;
        indiceZoom = (i + piezas.length) % piezas.length;
        pintarZoom();
      };

      section.querySelectorAll('[data-pm-zoom]').forEach((boton) => {
        boton.addEventListener('click', () => {
          const item = boton.closest('[data-pm-main-item]');
          const piezas = piezasAmpliables();
          const i = piezas.indexOf(item);
          indiceZoom = i >= 0 ? i : 0;
          pintarZoom();
        });
      });

      const botonPrev = lightbox.querySelector('[data-pm-lightbox-prev]');
      const botonNext = lightbox.querySelector('[data-pm-lightbox-next]');
      if (botonPrev) botonPrev.addEventListener('click', () => irAZoom(indiceZoom - 1));
      if (botonNext) botonNext.addEventListener('click', () => irAZoom(indiceZoom + 1));

      lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') irAZoom(indiceZoom + 1);
        if (e.key === 'ArrowLeft') irAZoom(indiceZoom - 1);
      });

      /* Deslizar en movil: un solo gesto horizontal, sin librerias. */
      const stage = lightbox.querySelector('[data-pm-lightbox-stage]');
      let tocadoEnX = null;
      if (stage) {
        stage.addEventListener('touchstart', (e) => {
          tocadoEnX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', (e) => {
          if (tocadoEnX === null) return;
          const dx = e.changedTouches[0].clientX - tocadoEnX;
          if (Math.abs(dx) > 40) irAZoom(indiceZoom + (dx < 0 ? 1 : -1));
          tocadoEnX = null;
        }, { passive: true });
      }
    }

    /* ---- Selector de estampado: "Show all N" ---------------------------- */
    const printPicker = section.querySelector('[data-print-picker]');
    const printMore = section.querySelector('[data-print-more]');
    if (printPicker && printMore) {
      printMore.addEventListener('click', () => {
        printPicker.classList.add('is-expanded');
        printMore.hidden = true;
      });
    }

    /* ---- Galeria por variante ----------------------------------------
       Cada imagen lleva su variante en data-media-group, sacada del prefijo
       del texto alternativo. Al cambiar de opcion se ocultan las que no
       pertenecen y se salta a la primera que si. Las imagenes sin grupo
       (diagramas, genericas) se ven siempre.                            */
    const opcionesElegidas = () => {
      const v = [];
      document.querySelectorAll('input[name^="options["]:checked, select[name^="options["]')
        .forEach((el) => { if (el.value) v.push(el.value.trim()); });
      return v;
    };

    const filtrarGaleria = () => {
      const sel = opcionesElegidas();
      if (!sel.length) return;
      const grupos = new Set();
      thumbs.forEach((t) => { if (t.dataset.mediaGroup) grupos.add(t.dataset.mediaGroup); });
      if (!grupos.size) return;                       /* producto sin galeria por variante */
      const activo = sel.find((s) => grupos.has(s));
      if (!activo) return;                            /* la opcion elegida no agrupa imagenes */

      let primera = null;
      const visible = (g) => !g || g === activo;
      thumbs.forEach((t) => {
        const ok = visible(t.dataset.mediaGroup);
        t.hidden = !ok;
        if (ok && primera === null) primera = t.dataset.pmThumb;
      });
      mains.forEach((m) => { m.dataset.hiddenByVariant = visible(m.dataset.mediaGroup) ? '' : '1'; });
      if (primera !== null) {
        thumbs.forEach((x) => x.classList.toggle('is-active', x.dataset.pmThumb === primera));
        mains.forEach((m) => m.classList.toggle('is-active', m.dataset.pmMainItem === primera));
      }
      refrescarContador();
    };

    /* ---- Seleccion de variante ------------------------------------------
       Las opciones se pintan como radios `options[...]` y /cart/add solo mira
       el <select name="id">. NADIE los sincronizaba: elegir "36 Blackout"
       metia en el carrito "21 The Keys". 146 de 242 variantes eran
       inalcanzables y en 23 productos se cobraba otro precio.

       Los trozos que dependen de la variante -precio, detalles, aviso de
       recogida y buscador de talla- se piden a Shopify YA RENDERIZADOS con
       ?variant=&section_id=. Recalcular aqui el precio o los detalles seria
       duplicar la logica del snippet y acabaria desincronizandose.          */
    const mapaEl = section.querySelector('[data-mapa-variantes]');
    const selectId = section.querySelector('[data-variant-id-select]');
    const seccionId = section.dataset.sectionId;
    let variantes = [];
    if (mapaEl) { try { variantes = JSON.parse(mapaEl.textContent); } catch (e) { variantes = []; } }

    const grupos = () => Array.from(section.querySelectorAll('.main-product__option'));

    const buscarVariante = () => {
      const elegidas = grupos().map((g) => {
        const marcado = g.querySelector('input[type="radio"]:checked');
        return marcado ? marcado.value : null;
      });
      if (!elegidas.length || elegidas.some((v) => v === null)) return null;
      return variantes.find((v) => elegidas.every((val, i) => v.opciones[i] === val)) || null;
    };

    /* 'calculadora' NO va en esta lista, y costo encontrarlo. Estaba, y el
       sintoma era exactamente el que describio el cliente: «cuando le doy al
       boton de la calculadora se esconde el resultado de la talla».

       La cadena: el boton calcula y pinta la talla -> `marca()` marca el radio
       de esa talla y dispara `change` -> este bloque cree que el comprador ha
       cambiado de variante y repinta las regiones -> el innerHTML de
       `[data-variante="calculadora"]` se sustituye por el que devuelve el
       servidor, que **no trae resultado porque el resultado es estado del
       navegador**. O sea: la calculadora se borraba a si misma justo al
       acertar, y solo al acertar. Si no encontraba talla, no marcaba radio, no
       disparaba el repintado y el aviso SI se quedaba en pantalla.

       Y no hay nada que repintar ahi: su tabla es la misma para todas las
       variantes. Estaba en la lista por inercia. */
    const REGIONES = ['precio', 'ficha', 'recogida', 'accesorio'];
    let ultimaPeticion = 0;

    /* ---- Accesorio a juego ----------------------------------------------
       El formulario manda `id` y `quantity`, que es lo unico que entiende
       /cart/add con un solo articulo. Para meter dos en la MISMA accion hay
       que hablarle en el formato `items[n][...]`, y los dos formatos no se
       pueden mezclar. Asi que al marcar la casilla se renombran los campos del
       producto principal y se habilitan los del accesorio; al desmarcarla se
       deshace. El envio en si lo sigue haciendo theme.js, que ya intercepta
       cualquier form[action$="/cart/add"] y lo manda por AJAX con FormData.

       Sin JavaScript la casilla no llega a marcarse nunca, los campos del
       accesorio siguen `disabled` y el formulario manda un solo articulo. */
    const idsAccesorio = () => ({
      check: section.querySelector('[data-addon-check]'),
      id: section.querySelector('[data-addon-id]'),
      qty: section.querySelector('[data-addon-qty]'),
    });

    const sincronizarAccesorio = () => {
      const { check, id, qty } = idsAccesorio();
      const cantidad = section.querySelector('.qty__input');
      const marcado = !!(check && check.checked);
      if (id) id.disabled = !marcado;
      if (qty) qty.disabled = !marcado;
      if (selectId) selectId.name = marcado ? 'items[0][id]' : 'id';
      if (cantidad) cantidad.name = marcado ? 'items[0][quantity]' : 'quantity';
    };

    section.addEventListener('change', (e) => {
      if (e.target.matches('[data-addon-check]')) sincronizarAccesorio();
    });
    sincronizarAccesorio();

    const refrescarRegiones = (variante) => {
      if (!seccionId) return;
      const mia = ++ultimaPeticion;
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variante.id);
      url.searchParams.set('section_id', seccionId);
      fetch(url.toString(), { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : null))
        .then((html) => {
          /* si el usuario ha vuelto a cambiar mientras llegaba, se descarta:
             sin esto la respuesta lenta pisa a la rapida y pinta otro precio */
          if (!html || mia !== ultimaPeticion) return;
          /* Si el comprador ya habia marcado el accesorio, cambiar de talla no
             puede desmarcarselo: la region se repinta con la talla nueva ya
             resuelta y se le devuelve la casilla como estaba. */
          const accesorioMarcado = !!(idsAccesorio().check || {}).checked;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          REGIONES.forEach((r) => {
            const nuevo = doc.querySelector('[data-variante="' + r + '"]');
            const viejo = section.querySelector('[data-variante="' + r + '"]');
            if (nuevo && viejo) viejo.innerHTML = nuevo.innerHTML;
          });
          const checkNuevo = idsAccesorio().check;
          if (checkNuevo) checkNuevo.checked = accesorioMarcado;
          sincronizarAccesorio();
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: { id: variante.id } }
          }));
        })
        .catch(() => {});
    };

    const alElegirOpcion = () => {
      filtrarGaleria();
      grupos().forEach((g) => {
        const marcado = g.querySelector('input[type="radio"]:checked');
        const etiqueta = g.querySelector('[data-selected-option]');
        if (marcado && etiqueta) etiqueta.textContent = marcado.value;
      });
      const v = buscarVariante();
      if (!v) return;
      if (selectId) selectId.value = v.id;
      /* la URL lleva la variante: al recargar o al compartir sale la elegida */
      const visible = new URL(window.location.href);
      visible.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', visible);
      const boton = section.querySelector('[data-add-to-cart], button[type="submit"]');
      if (boton) boton.disabled = !v.disponible;
      refrescarRegiones(v);
    };

    section.addEventListener('change', (e) => {
      if (e.target.name && e.target.name.indexOf('options[') === 0) alElegirOpcion();
    });
    filtrarGaleria();
    refrescarContador();

    section.querySelectorAll('.option-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        const input = pill.querySelector('input');
        if (!input) return;
        const name = input.name;
        section.querySelectorAll(`.option-pill input[name="${name}"]`).forEach((sib) => {
          sib.closest('.option-pill').classList.toggle('is-active', sib === input);
        });
        /* el radio dentro de un <label> no siempre emite change al clicar el
           label: se dispara a mano para no depender de ello */
        if (!input.checked) { input.checked = true; }
        alElegirOpcion();
      });
    });

    section.querySelectorAll('[data-qty-delta]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.dataset.qtyDelta, 10);
        const input = btn.parentElement.querySelector('.qty__input');
        if (!input) return;
        /* El limite por pedido que se anuncia arriba se cumple aqui: prometer
           "maximo 5" y dejar subir a doce seria peor que no decirlo. */
        const tope = parseInt(input.dataset.qtyMax, 10);
        let next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        if (tope > 0) next = Math.min(next, tope);
        input.value = next;
      });
    });

    section.querySelectorAll('[data-pm-pack]').forEach((pack) => {
      pack.addEventListener('click', () => {
        section.querySelectorAll('[data-pm-pack]').forEach((p) => p.classList.toggle('is-active', p === pack));
        const qtyInput = section.querySelector('.qty__input');
        if (qtyInput) qtyInput.value = pack.dataset.qty;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-slider]').forEach((slider) => {
      const after = slider.querySelector('[data-ba-after]');
      const range = slider.querySelector('[data-ba-range]');
      const handle = slider.querySelector('[data-ba-handle]');
      if (!after || !range || !handle) return;
      range.addEventListener('input', () => {
        const v = parseFloat(range.value);
        after.style.clipPath = `inset(0 0 0 ${v}%)`;
        handle.style.left = `${v}%`;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-form"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-product-form-section]');
    if (!section) return;
    const form = section.querySelector('[data-product-form]');
    const variantSelect = section.querySelector('[data-variant-id]');
    const productId = section.getAttribute('data-product-id');

    // Quantity steppers
    section.querySelectorAll('[data-qty-delta]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = section.querySelector('.quantity__input');
        const delta = parseInt(btn.getAttribute('data-qty-delta'), 10) || 0;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
      });
    });

    // Variant option change → update hidden id + price
    section.querySelectorAll('[data-product-option]').forEach((input) => {
      input.addEventListener('change', () => {
        const selectedOptions = [];
        section.querySelectorAll('[data-product-option]:checked').forEach((opt) => {
          selectedOptions.push({ position: parseInt(opt.getAttribute('data-position'), 10), value: opt.value });
        });

        // Find matching variant
        fetch(`/products/${section.dataset.productHandle || ''}.js`).catch(() => null);
        // Fallback: use the <select name="id"> approach
        if (variantSelect) {
          const candidate = Array.from(variantSelect.options).find((opt) => {
            return selectedOptions.every((so) => opt.textContent.includes(so.value));
          });
          if (candidate) {
            variantSelect.value = candidate.value;
            // Update displayed selected value
            selectedOptions.forEach((so) => {
              const span = section.querySelector(`[data-selected-option="${so.position}"]`);
              if (span) span.textContent = so.value;
            });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-media]');
    if (!root) return;
    const mains = root.querySelectorAll('[data-pm-main-item]');
    const thumbs = root.querySelectorAll('[data-pm-thumb]');
    const prev = root.querySelector('[data-pm-prev]');
    const next = root.querySelector('[data-pm-next]');
    let active = 0;

    const setActive = (i) => {
      active = (i + mains.length) % mains.length;
      mains.forEach((m, idx) => m.classList.toggle('is-active', idx === active));
      thumbs.forEach((t, idx) => {
        t.classList.toggle('is-active', idx === active);
        t.setAttribute('aria-selected', idx === active ? 'true' : 'false');
      });
    };

    thumbs.forEach((t, idx) => t.addEventListener('click', () => setActive(idx)));
    if (prev) prev.addEventListener('click', () => setActive(active - 1));
    if (next) next.addEventListener('click', () => setActive(active + 1));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // TRES cosas que estaban mal y dejaban «Cargando recomendaciones…» para
    // siempre, a la vista del comprador:
    //
    // 1. Pedía `section_id=product-related`, que NO EXISTE: la sección se llama
    //    `product-related-bundle`. Medido: la primera da 404, la segunda 200.
    // 2. `querySelector` en singular. La ficha lleva DOS bloques —«Completa la mesa»
    //    y «Tambien te puede gustar»—, así que el segundo no se rellenaba nunca.
    // 3. El `.catch` vacío se tragaba el fallo y dejaba el mensaje de carga
    //    puesto. Si falla, ahora la sección se retira: mejor que no salga nada a
    //    que se quede cargando eternamente.
    const bloques = document.querySelectorAll('[data-product-recommendations]');
    bloques.forEach(function (el) {
      if (el.querySelectorAll('.product-card').length > 0) return;
      const productId = el.dataset.productId;
      const limit = el.dataset.limit || 4;
      // 02/10/2026 · sin la raíz del idioma, en /es llegaban nombres y botones en inglés
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${raiz}recommendations/products?section_id=product-related-bundle`
                + `&product_id=${productId}&limit=${limit}`;
      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = parsed.querySelector('[data-product-recommendations] .product-related__grid');
          const grid = el.querySelector('.product-related__grid');
          if (!newGrid || !grid || !newGrid.querySelector('.product-card')) {
            throw new Error('sin recomendaciones');
          }
          grid.innerHTML = newGrid.innerHTML;
        })
        .catch(function () {
          const seccion = el.closest('.product-related') || el;
          seccion.hidden = true;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-atc"]) return;
  try {
    
  (function () {
    const atc = document.querySelector('[data-sticky-atc]');
    // [data-atc-btn] solo existe en sections/product-form.liquid, que NO está en
    // templates/product.json: la ficha la pinta main-product.liquid. Buscando solo
    // ese selector, la barra no se activaba nunca. Ahora se prueban candidatos.
    const trigger =
      document.querySelector('[data-product-form-section] [data-atc-btn]') ||
      document.querySelector('.main-product__atc') ||
      document.querySelector('main form[action$="/cart/add"] button[type="submit"]');
    if (!atc || !trigger) return;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (isMobile()) {
          atc.setAttribute('aria-hidden', 'false');
          return;
        }
        // Desktop: show when original ATC is out of view
        atc.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0.1 });

    observer.observe(trigger);

    /* En movil la barra tiene que estar desde el principio. El observer dispara
       una sola vez al empezar a observar, y si en ese momento el boton original
       ya estaba fuera de vista podria dejarla escondida. */
    if (isMobile()) atc.setAttribute('aria-hidden', 'false');

    // Sincronizar la variante elegida.
    // [data-variant-id] no existe en main-product.liquid: el selector real es
    // <select name="id">. Con el selector antiguo, la barra podía añadir al carrito
    // una variante distinta de la que el cliente había elegido.
    const variantSel =
      document.querySelector('[data-variant-id]') ||
      document.querySelector('main form[action$="/cart/add"] select[name="id"]') ||
      document.querySelector('main form[action$="/cart/add"] [name="id"]');
    const stickyInput = atc.querySelector('[data-sticky-atc-variant]');
    if (variantSel && stickyInput) {
      const sync = () => { stickyInput.value = variantSel.value; };
      sync();
      variantSel.addEventListener('change', sync);
      document.addEventListener('change', (e) => { if (e.target.matches('[data-product-option]')) setTimeout(sync, 0); });
    }

    /* --- Repintar el PRECIO, no solo el id oculto ------------------------
       Lo de arriba cambiaba el `id` que se manda al carrito, pero la barra
       seguía enseñando el precio de la primera variante: se elegía la de 120 ml
       y abajo seguía poniendo el de 60. Se añade al carrito lo correcto y se lee
       lo incorrecto, que es peor que no enseñar precio.

       Se pide esta misma sección al servidor con ?variant=&section_id=, que es
       el patrón de la Section Rendering API, y se sustituye SOLO el interior de
       [data-sticky-atc-content]. El <aside> de fuera no se toca: es quien tiene
       el observer enganchado, y el bloque javascript de una sección NO se vuelve
       a ejecutar tras repintarla.
       https://shopify.dev/docs/storefronts/themes/best-practices/performance/use-section-rendering-api

       Portado de shopjowi.com, donde ya está probado. */
    const seccionId = atc.getAttribute('data-section-id');
    let ultima = 0;

    const repintar = (variantId) => {
      const input = atc.querySelector('[data-sticky-atc-variant]');
      if (input) input.value = variantId;
      if (!seccionId) return;

      const mia = ++ultima;          // si el cliente cambia rápido, gana la última
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', seccionId);
      fetch(url.toString(), { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : null))
        .then((html) => {
          if (!html || mia !== ultima) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nuevo = doc.querySelector('[data-sticky-atc-content]');
          const viejo = atc.querySelector('[data-sticky-atc-content]');
          if (nuevo && viejo) viejo.innerHTML = nuevo.innerHTML;
        })
        .catch(() => {});
    };

    // La ficha ya publica `variant:change`: ese es el contrato bueno.
    document.addEventListener('variant:change', (e) => {
      const id = e.detail && e.detail.variant && e.detail.variant.id;
      if (id) repintar(id);
    });

    // Respaldo por si algún día la ficha dejase de publicar el evento.
    document.addEventListener('change', (e) => {
      if (!e.target.name || e.target.name.indexOf('options[') !== 0) return;
      setTimeout(() => {
        const sel = document.querySelector('[data-variant-id-select]') || variantSel;
        if (sel && sel.value) repintar(sel.value);
      }, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
